import {React, useRef } from 'react';
import './OperationsDetail.scss'
// import VinPopIn from './VinPopIn';
import { useState } from 'react';
// import { Select } from '../Forms/Forms';
// import { setMileageStep, setSelectedMileageStep } from '../../redux-files/actions/action';

import { isMobile } from '../../helpers/helpers';
import { useSelector } from 'react-redux';
// import { useEffect } from 'react';
// import fetchApiData from '../../apiHandlers/fetchApiData';
// import ForfaitList from './ForfaitList';
import CONSTANTS from '../../Constants';
import OperationDetailItem from './OperationDetailItem';
import ErrorBoundary from '../ErrorBoundary';
import { pushEventToGTM } from '../../helpers/trackerManager';

const OperationsDetail = (props) => {
    // const dealer = useSelector(state => state.ndel_store.dealer)
    const vehicleInfo = useSelector(state => state.ndel_store.vehicleInfo)
    // const selectedForfaitFromStore = useSelector(state => state.ndel_store.selectedForfaits)
    const [showVinPopIn, setShowVinPopIn] = useState(false)
    const [showForfaits, setShowForfaits] = useState(false)
    // const [ShowMileagePas, setShowMileagePas] = useState(false)
    // const [isPasKiloDisabled, setIsPasKiloDisabled] = useState(true)
    // const [pasKilometriqueList, setPasKilometriqueList] = useState([])
    // const [selectedPasKilometrique, setSelectedPasKilometrique] = useState('')
    // const [revisionConstructorForfait, setRevisionConstructorForfait] = useState([])
    // const [selectedForfaits, setSelectedForfaits] = useState(selectedForfaitFromStore)
    // const dispatch = useDispatch()
    // const REVIS_CONSTRU_CODE_FAMLILY = 'FCT0002'
    // useEffect(() => {
    //     setSelectedForfaits(selectedForfaitFromStore)
    //     console.log('run useEffect ...')
    // }, [selectedForfaitFromStore]) // if the selectedOperations changed test if it is a revision Constructeur
   
    const handleShowForfaits = (item) => {
        const selectedElementIndex = props.selectedOperations.indexOf(item);
        for (let index = 0; index < props.selectedOperations.length; index++) {
            if (index !== selectedElementIndex) {
                props.selectedOperations[index].isForfaitsBlockOpen = false
            }
        }
        if (!item.interventionForfaits[0].isConstructeur) {
            item.isForfaitsBlockOpen = !item.isForfaitsBlockOpen
            setShowForfaits(!showForfaits) //update the DOM to take in consideration the item.isForfaitsBlockOpen change ! 
        }
        else if (vehicleInfo.SerialNumber.length < 1) {
            !!item.interventionForfaits.length && setShowVinPopIn(item.interventionForfaits[0].isConstructeur)
            pushEventToGTM({
                pageName: 'services - révision',
                eventAction: 'Display::Popin::VIN',
                eventLabel: item.interventionLabel,
                eventCategory: 'content'
            })
        }
        else{
            item.isForfaitsBlockOpen = !item.isForfaitsBlockOpen
            setShowForfaits(!showForfaits) //update the DOM to take in consideration the item.isForfaitsBlockOpen change ! 
        }

    }
    const handleClickOutsideVinPopin = (e, myRef) => {
        if (myRef.current && !myRef.current.contains(e.target)) {
            setShowVinPopIn(false)
        }
    }

    
    const operationDetailsRef = useRef(null)
    
    return (
        <>
            {!isMobile() && <div className='operations-detail-title'>{CONSTANTS.LABELS.needs_basket_title}</div>}
            <ul className='operations-detail-list'>

                {
                    props.selectedOperations.map(item => {
                        return (
                            <ErrorBoundary key={item.interventionId}>
                                <OperationDetailItem key={item.interventionId}
                                    ref={operationDetailsRef}
                                    operation={item}
                                    handleRemove={props.handleRemove}
                                    onShowForfait={handleShowForfaits}
                                    showVinPopInForConstructor={showVinPopIn}
                                    onClickOutsideVinPopin={handleClickOutsideVinPopin}
                                    handleClosePopupVin={() => setShowVinPopIn(false)}
                                />
                            </ErrorBoundary>
                        )
                    })
                }
            </ul>

        </>
    );

}
export default OperationsDetail;